// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-5b331e6a]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.goods-data[data-v-5b331e6a] {\n  padding: 20px;\n  background: #fff;\n}\n.btn-area[data-v-5b331e6a] {\n  margin-top: 40px;\n  padding-left: 50px;\n}", ""]);
// Exports
module.exports = exports;
